import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./extent.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./extent.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Injectable } from "@angular/core";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
let ExtentComponent = class ExtentComponent {
    constructor() { }
    addExtentTool(mapView) {
        const textContainer = document.getElementsByTagName("app-extent-tool")[0];
        const textExtent = document.getElementById("extent");
        const textSpatialRef = document.getElementById("spatialRef");
        const textCenter = document.getElementById("center");
        const textZoom = document.getElementById("zoom");
        this.updateExtent(mapView, textExtent, textSpatialRef, textCenter, textZoom);
        return textContainer;
    }
    updateExtent(mapView, textExtent, textSpatialRef, textCenter, textZoom) {
        reactiveUtils.when(() => mapView?.stationary === true, () => {
            if (textExtent !== null && textExtent.innerHTML !== null) {
                if (mapView.extent) {
                    textExtent.innerHTML = "<br> xmin: " + mapView.extent.xmin.toFixed(2) + "," +
                        "<br> xmax: " + mapView.extent.xmax.toFixed(2) + "," +
                        "<br> ymin: " + mapView.extent.ymin.toFixed(2) + "," +
                        "<br> ymax: " + mapView.extent.ymax.toFixed(2);
                }
                if (mapView.spatialReference) {
                    textSpatialRef.innerHTML = "<br> spatial reference: wkid { " + mapView.spatialReference.wkid + "}";
                }
                if (mapView.center) {
                    textCenter.innerHTML = "<br> center: [" +
                        mapView.center.x.toFixed(2) +
                        ", " +
                        mapView.center.y.toFixed(2) + "]";
                }
                if (mapView.zoom) {
                    textZoom.innerHTML = "<br> zoom: " + mapView.zoom.toFixed(0);
                }
            }
        });
    }
    static ctorParameters = () => [];
};
ExtentComponent = __decorate([
    Injectable({
        providedIn: "root"
    }),
    Component({
        selector: "app-extent-tool",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ExtentComponent);
export { ExtentComponent };
